import { select, selectAll } from "../core/dom";

export function initScrollIndicator(): void {
  const indicator = select<HTMLElement>(".scroll-indicator");
  const number = select<HTMLElement>(".scroll-indicator-number");
  if (!indicator || !number) return;

  const digits = selectAll<HTMLElement>("span", number);
  const darkSections = selectAll<HTMLElement>("#footer");
  let scheduled = false;

  const update = (): void => {
    const scrollTop = window.scrollY;
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const percentage = Math.round((scrollableHeight > 0 ? scrollTop / scrollableHeight : 0) * 100);
    const formatted = String(percentage).padStart(3, "0");

    if (digits.length === 3) {
      digits.forEach((digit, index) => {
        digit.textContent = formatted[index] ?? "0";
      });
    } else {
      number.textContent = formatted;
    }

    indicator.classList.toggle("is-visible", scrollTop > 250);

    const indicatorRect = indicator.getBoundingClientRect();
    const indicatorCenter = indicatorRect.top + indicatorRect.height / 2;
    const isOverDarkSection = darkSections.some((section) => {
      const rect = section.getBoundingClientRect();
      return indicatorCenter >= rect.top && indicatorCenter <= rect.bottom;
    });

    indicator.classList.toggle("is-dark", isOverDarkSection);
    scheduled = false;
  };

  const scheduleUpdate = (): void => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);
  update();
}
